import React, { useState, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import theme from "../../themes/default";
import Heading from "./../../atoms/Heading";
import AdditionalItem from "./../../molecules/AdditionalItem";
import { ReactComponent as BackArrow } from "./../../atoms/icons/chevron-back.svg";

const Wrap = styled.div`
    width: 100%;

    @media (min-width: 990px) {
    }
`;

const Menu = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding-top: 50px;
    padding-bottom: 10px;
`;

const MenuContent = styled.div`
    p {
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
    }

    @media (max-width: 989px) {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 15px;

        button {
            left: 0;
        }

        h1 {
            padding-left: 42px;
        }
    }
`;

const MenuButtons = styled.div`
    button + button {
        margin-left: 15px;
    }

    @media (max-width: 989px) {
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 7;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 12px 40px;
        background-color: #fff;

        button {
            min-width: 230px;
        }

        button + button {
            margin-top: 12px;
            margin-left: 0;
        }
    }
`;

const MainHeading = styled(Heading)`
    margin-bottom: 16px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 40px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -2px;
`;

const BackButton = styled.button`
    position: absolute;
    top: 56px;
    left: -40px;
    border: none;
    background: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    svg {
        display: block;
    }
`;

const NoButton = styled.button`
    position: relative;
    border-radius: 28px;
    background-color: #fff;
    border: solid 1px var(--color-primary);
    padding: 12px 40px;
    outline: none;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: 0.94px;
    text-align: center;
    color: var(--color-primary);
    text-transform: uppercase;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    @keyframes ld-spin {
        0% {
            animation-timing-function: cubic-bezier(
                0.5856,
                0.0703,
                0.4143,
                0.9297
            );
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    span {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin: -10px;
        opacity: 0;
        z-index: -1;
        transition: all 0.3s;
        transition-timing-function: ease-in;
        animation: ld-spin 1s infinite linear;

        &::after {
            content: " ";
            display: block;
            width: 40px;
            height: 40px;
            box-sizing: border-box;
            border-radius: 50%;
            border: 5px solid var(--color-primary);
            border-left-color: transparent;
            transform-origin: 0 0;
            transform: translateZ(0) scale(0.5);
            backface-visibility: hidden;
        }
    }

    &.loading {
        span {
            opacity: 1;
            z-index: auto;
            visibility: visible;
        }

        b {
            opacity: 0.3;
        }
    }
`;

const ProceedButton = styled.button`
    position: relative;
    border-radius: 28px;
    background-color: var(--color-primary);
    border: none;
    padding: 12px 40px;
    outline: none;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;
    font-size: 15px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.6;
    letter-spacing: 0.94px;
    text-align: center;
    color: #fff;
    text-transform: uppercase;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    &:disabled:not(.loading) {
        background-color: #e6e6e6;
        color: #6e6e6e;
    }

    @keyframes ld-spin {
        0% {
            animation-timing-function: cubic-bezier(
                0.5856,
                0.0703,
                0.4143,
                0.9297
            );
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    span {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin: -10px;
        opacity: 0;
        z-index: -1;
        transition: all 0.3s;
        transition-timing-function: ease-in;
        animation: ld-spin 1s infinite linear;

        &::after {
            content: " ";
            display: block;
            width: 40px;
            height: 40px;
            box-sizing: border-box;
            border-radius: 50%;
            border: 5px solid #fff;
            border-left-color: transparent;
            transform-origin: 0 0;
            transform: translateZ(0) scale(0.5);
            backface-visibility: hidden;
        }
    }

    &.loading {
        span {
            opacity: 1;
            z-index: auto;
            visibility: visible;
        }

        b {
            opacity: 0.3;
        }
    }
`;

const SectionWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    position: relative;
`;

function AddIns(props) {
    const { additionals, selectedAddIns, mode } = props;
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState('');

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    const handleMealChange = (item) => {
        props.handleMealChange(item);
    };

    const handleBackClick = () => {
        props.handleBackClick();
    };

    const handleToCheckoutClick = (clearCart, flag) => {
        setLoading(true);
        setStatus(flag, s => props.handleToCheckoutClick(clearCart));
    };

    const handleSave = () => {
        setLoading(true, s => props.handleSaveCharge());
    };

    const isDisabled = !selectedAddIns.length || loading ? true : false;
    const filteredAdditionals = additionals.filter((additional) => {
        let mark = true;

        additional.tags.forEach((tag) => {
            let mealTag = tag.toLowerCase();
            if (mealTag === "subscription") mark = false;
        });

        return mark;
    });

    return (
        <ThemeProvider theme={theme}>
            <Wrap>
                <Menu>
                    <MenuContent>
                        <BackButton onClick={handleBackClick}>
                            <BackArrow />
                        </BackButton>
                        <MainHeading>Add-Ins Menu</MainHeading>
                        <p>
                            Would you like to add any of these items to your
                            order?
                        </p>
                    </MenuContent>
                    {mode === "constructor" && (
                        <MenuButtons>
                            <NoButton
                                onClick={() => {
                                    handleToCheckoutClick(true, "no");
                                }}
                                className={status === "no" ? "loading" : ""}
                            >
                                <span></span>
                                <b>No, Thanks</b>
                            </NoButton>
                            <ProceedButton
                                onClick={() => {
                                    handleToCheckoutClick(
                                        false,
                                        "yes"
                                    );
                                }}
                                disabled={isDisabled}
                                className={
                                    status === "yes" ? "loading" : ""
                                }
                            >
                                <span></span>
                                <b>Proceed to cart</b>
                            </ProceedButton>
                        </MenuButtons>
                    )}
                    {mode === "account" && (
                        <MenuButtons>
                            <ProceedButton
                                onClick={handleSave}
                                className={loading ? "loading" : ""}
                            >
                                <span></span>
                                <b>Save</b>
                            </ProceedButton>
                        </MenuButtons>
                    )}
                </Menu>
                <SectionWrap>
                    {filteredAdditionals.map((meal) => {
                        let additionalsQuantitySelected = 0;
                        selectedAddIns.forEach((item) => {
                            if (meal.id === item.id) {
                                additionalsQuantitySelected = item.quantity;
                                return false;
                            }
                        });
                        return (
                            <AdditionalItem
                                id={meal.id}
                                title={meal.title}
                                image={meal.image}
                                tags={meal.tags}
                                key={meal.id}
                                variants={meal.variants}
                                mealChange={handleMealChange}
                                images={meal.images}
                                handle={meal.handle}
                                quantitySelected={
                                    additionalsQuantitySelected
                                }
                                frequence={"recurring"}
                            />
                        );
                    })}
                </SectionWrap>
            </Wrap>
        </ThemeProvider>
    );
}

export default AddIns;
